module.exports = __webpack_public_path__ + "static/media/new passport 1-01.fb0e7fca.svg";